
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'data-privacy-request-ui',
  currentProjectVersion: 'static-1.5209',
  depVersions: {
  "data-privacy-request-ui": "static-1.5209",
  "data-fetching-client": "static-1.9358",
  "head-dlb": "static-1.4702",
  "history": "static-4.47",
  "hs-test-utils": "static-1.7664",
  "hub-http-shared-msw-handlers": "static-1.9177",
  "hubspot-dlb": "static-2.1773",
  "HubStyleTokens": "static-2.11103",
  "I18n": "static-7.1537",
  "jasmine-runner": "static-1.6135",
  "privacy-center-public-service-types": "static-1.4472",
  "quartz": "static-1.6558",
  "react-dlb": "static-1.69",
  "react-router-dom": "static-5.26",
  "ui-components-test-utils": "static-1.5241",
  "UIComponents": "static-3.8050",
  "webpack-env": "static-1.54",
  "apollo-stack-hubspot": "static-3.79",
  "foundations-assets": "static-1.4515",
  "foundations-components": "static-1.7269",
  "foundations-components-test-utils": "static-1.4752",
  "foundations-theming": "static-1.4084",
  "hub-http": "static-1.5872",
  "quartz-config": "static-1.336",
  "quartz-core": "static-1.5777",
  "quick-fetch": "static-1.3621",
  "raven": "static-3.5564",
  "react": "static-7.175",
  "react-rhumb": "static-1.16316",
  "SharedI18nStrings": "static-1.179",
  "ui-addon-i18n": "static-1.10810",
  "usage-tracker": "static-1.7019",
  "usage-tracker-anonymous": "static-1.5436",
  "usage-tracker-core": "static-1.6869",
  "enviro": "static-4.371",
  "hs-promise-rejection-tracking": "static-1.5234",
  "PortalIdParser": "static-2.334",
  "raven-hubspot": "static-1.5871",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.3825",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9296",
  "react-redux": "static-7.65",
  "redux": "static-4.16",
  "styled-components": "static-2.83",
  "bend-plugin-trellis-migration": "static-1.3119",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2835",
  "quartz-webpack": "static-1.2782",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.75",
  "HeadJS": "static-2.686",
  "framer-motion": "static-1.64",
  "hs-test-utils-bend-plugin": "static-1.2775",
  "msw": "static-1.39",
  "testing-library": "static-1.145",
  "ts-schema": "static-1.3796",
  "i18n-data": "static-1.214",
  "moment-timezone": "static-5.76",
  "react-utils": "static-2.5069",
  "StyleGuideUI": "static-3.481",
  "jasmine": "static-4.4014",
  "rpc-client-utils": "static-1.4288",
  "HubStyle": "static-2.11411",
  "ui-addon-draggable": "static-3.4428",
  "cssUtils": "static-1.693",
  "hs-story-utils": "static-1.9112",
  "icons": "static-2.610",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.92",
  "ui-images": "static-2.1055",
  "bend-plugin-foundations-components": "static-1.3538",
  "floating-ui": "static-1.49",
  "foundations-theming-specialty": "static-1.1800",
  "react-aria": "static-1.59",
  "tanstack-table": "static-1.48",
  "trellis-assets": "static-1.951",
  "ui-fonts": "static-1.365",
  "bend-plugin-foundations-theming": "static-1.2567",
  "foundations-theming-base": "static-1.3069",
  "stylex": "static-1.25",
  "dispatcher": "static-1.129",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.766",
  "hubspotter-http": "static-1.4370",
  "mobile-manifest-mixins": "static-1.459",
  "quartz-auth": "static-1.233",
  "quartz-head": "static-1.223",
  "quartz-i18n": "static-1.233",
  "quartz-test": "static-1.233",
  "csstype": "static-1.50",
  "react-input-autosize": "static-2.17",
  "bender-build-tools": "static-1.2795",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-flip-move": "static-1.63",
  "sassPrefix": "static-1.149",
  "hubspotter-http-shared-msw-handlers": "static-1.9175"
},
  depPathPrefixes: {
  "data-privacy-request-ui": "/data-privacy-request-ui/static-1.5209",
  "data-fetching-client": "/data-fetching-client/static-1.9358",
  "head-dlb": "/head-dlb/static-1.4702",
  "history": "/history/static-4.47",
  "hs-test-utils": "/hs-test-utils/static-1.7664",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9177",
  "hubspot-dlb": "/hubspot-dlb/static-2.1773",
  "HubStyleTokens": "/HubStyleTokens/static-2.11103",
  "I18n": "/I18n/static-7.1537",
  "jasmine-runner": "/jasmine-runner/static-1.6135",
  "privacy-center-public-service-types": "/privacy-center-public-service-types/static-1.4472",
  "quartz": "/quartz/static-1.6558",
  "react-dlb": "/react-dlb/static-1.69",
  "react-router-dom": "/react-router-dom/static-5.26",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5241",
  "UIComponents": "/UIComponents/static-3.8050",
  "webpack-env": "/webpack-env/static-1.54",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "foundations-assets": "/foundations-assets/static-1.4515",
  "foundations-components": "/foundations-components/static-1.7269",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4752",
  "foundations-theming": "/foundations-theming/static-1.4084",
  "hub-http": "/hub-http/static-1.5872",
  "quartz-config": "/quartz-config/static-1.336",
  "quartz-core": "/quartz-core/static-1.5777",
  "quick-fetch": "/quick-fetch/static-1.3621",
  "raven": "/raven/static-3.5564",
  "react": "/react/static-7.175",
  "react-rhumb": "/react-rhumb/static-1.16316",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10810",
  "usage-tracker": "/usage-tracker/static-1.7019",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5436",
  "usage-tracker-core": "/usage-tracker-core/static-1.6869",
  "enviro": "/enviro/static-4.371",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5234",
  "PortalIdParser": "/PortalIdParser/static-2.334",
  "raven-hubspot": "/raven-hubspot/static-1.5871",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3825",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9296",
  "react-redux": "/react-redux/static-7.65",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.83",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3119",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2835",
  "quartz-webpack": "/quartz-webpack/static-1.2782",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.75",
  "HeadJS": "/HeadJS/static-2.686",
  "framer-motion": "/framer-motion/static-1.64",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2775",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.145",
  "ts-schema": "/ts-schema/static-1.3796",
  "i18n-data": "/i18n-data/static-1.214",
  "moment-timezone": "/moment-timezone/static-5.76",
  "react-utils": "/react-utils/static-2.5069",
  "StyleGuideUI": "/StyleGuideUI/static-3.481",
  "jasmine": "/jasmine/static-4.4014",
  "rpc-client-utils": "/rpc-client-utils/static-1.4288",
  "HubStyle": "/HubStyle/static-2.11411",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4428",
  "cssUtils": "/cssUtils/static-1.693",
  "hs-story-utils": "/hs-story-utils/static-1.9112",
  "icons": "/icons/static-2.610",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.92",
  "ui-images": "/ui-images/static-2.1055",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3538",
  "floating-ui": "/floating-ui/static-1.49",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1800",
  "react-aria": "/react-aria/static-1.59",
  "tanstack-table": "/tanstack-table/static-1.48",
  "trellis-assets": "/trellis-assets/static-1.951",
  "ui-fonts": "/ui-fonts/static-1.365",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2567",
  "foundations-theming-base": "/foundations-theming-base/static-1.3069",
  "stylex": "/stylex/static-1.25",
  "dispatcher": "/dispatcher/static-1.129",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.766",
  "hubspotter-http": "/hubspotter-http/static-1.4370",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.459",
  "quartz-auth": "/quartz-auth/static-1.233",
  "quartz-head": "/quartz-head/static-1.223",
  "quartz-i18n": "/quartz-i18n/static-1.233",
  "quartz-test": "/quartz-test/static-1.233",
  "csstype": "/csstype/static-1.50",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "bender-build-tools": "/bender-build-tools/static-1.2795",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-flip-move": "/react-flip-move/static-1.63",
  "sassPrefix": "/sassPrefix/static-1.149",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9175"
}
};
